import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addTagRule,
  fetchTagRegexes,
  setSelectedTagRegexesSet,
  updateTagRuleAction,
} from "../../../../redux/reducers/TagRegexes";
import Select from "react-select";
import { ReduxState } from "../../../../redux";
import { groupBy } from "lodash";
import { Button, Row, Form, Col, Modal, Alert } from "react-bootstrap";
import {
  deleteTagRegexes,
  deleteTagRegexesSet,
} from "../../../../docuclipper/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getCustomUi } from "../../../Docuclipper/ConfirmAlert/ConfirmAlert";
import { confirmAlert } from "react-confirm-alert";
import TagRuleForm from "./TagRule";
import { createAlert } from "src/redux/reducers/Alerts";

export const TagRules: React.FC = () => {
  const { tagRegexesSets, selectedTagRegexesSet, tagRules } = useSelector(
    (state: ReduxState) => state.TagRegexes
  );

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(fetchTagRegexes("tag"));
  }, []);
  const lsKey = "docuclipper.ui.selectedRuleGroup";
  React.useEffect(() => {
    const savedSelection = localStorage.getItem(lsKey);
    if (savedSelection) {
      dispatch(setSelectedTagRegexesSet(savedSelection));
    }
  }, [tagRegexesSets.length]);

  const names = Object.keys(groupBy(tagRegexesSets, "name"));

  const hideStr = (x: string) =>
    x === "c89e2ac11db6184500f0933279a407b3" ? "default" : x;

  const [showAddRule, setShowAddRule] = React.useState(false);

  const toggleAdd = () => setShowAddRule(!showAddRule);

  const isDefault = selectedTagRegexesSet
    ? selectedTagRegexesSet.name === "c89e2ac11db6184500f0933279a407b3"
    : false;
  return (
    <div>
      <Row>
        <Col>
          <Select
            options={names.map((x) => ({
              label: hideStr(x),
              value: x,
            }))}
            value={
              selectedTagRegexesSet
                ? {
                    label: hideStr(selectedTagRegexesSet.name),
                    value: selectedTagRegexesSet.id as string,
                  }
                : null
            }
            onChange={(value) => {
              if (value) {
                dispatch(setSelectedTagRegexesSet(value.value));
                localStorage.setItem(lsKey, value.value);
              }
            }}
          />
        </Col>

        {!isDefault && (
          <Button
            variant="link"
            onClick={() => {
              confirmAlert({
                customUI: getCustomUi({
                  onConfirm: () => {
                    if (selectedTagRegexesSet) {
                      deleteTagRegexesSet(
                        selectedTagRegexesSet.name,
                        selectedTagRegexesSet.type
                      )
                        .then((rsp) => {
                          dispatch(fetchTagRegexes("tag"));
                          if (tagRegexesSets.length > 0) {
                            dispatch(
                              setSelectedTagRegexesSet(tagRegexesSets[0].name)
                            );
                          } else {
                            dispatch(setSelectedTagRegexesSet(""));
                          }
                        })
                        .catch((err) =>
                          dispatch(
                            createAlert({
                              message: err.message || "Error deleting. Please try again.",
                              timeout: 0,
                              type: "error",
                            })
                          )
                        );
                    }
                  },
                  confirmCTA: "Delete",
                  cancelCTA: "Cancel",
                  getMessage: () => (
                    <div
                      className="div--confirm-job-delete"
                      style={{ marginBottom: "20px" }}
                    >
                      <span>{`Are you sure you want to delete this Rule group?`}</span>
                    </div>
                  ),
                }),
              });
            }}
          >
            <FontAwesomeIcon icon="trash" />
            <span className="ml-1">Delete</span>
          </Button>
        )}
      </Row>
      <Row>
        <Col md="4"></Col>

        <Col md="4">
          <Button
            data-cy="tag-rules-add-rule-btn"
            variant="primary"
            onClick={toggleAdd}
          >
            <FontAwesomeIcon icon="plus"></FontAwesomeIcon>
            <span className="ml-1">Add Rule</span>
          </Button>
          <Modal size="xl" show={showAddRule} onHide={toggleAdd}>
            <Modal.Header closeButton>
              <Modal.Title>Add Rule</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <TagRuleForm
                rule={null}
                onSubmit={(rule) => {
                  dispatch(addTagRule(rule));
                  setShowAddRule(false);
                }}
              />
            </Modal.Body>
          </Modal>
        </Col>
      </Row>
      <div className="h3">Rules</div>
      {tagRules.length === 0 && (
        <Alert variant="info" data-cy="tag-rules-empty">No rules yet. Add one to start categorizing transactions automatically.</Alert>
      )}
      <div data-cy="tag-rules-list">
        {tagRules.map((rule) => {
          return (
            <div key={rule.id} data-cy="tag-rules-row" data-tag={rule.tag}>
              <Row>
                <Col>
                  <Form.Label className="mt-1">
                    <strong data-cy="tag-rules-row-tag">{rule.tag}</strong>
                  </Form.Label>
                  <Button
                    data-cy="tag-rules-row-delete"
                    variant="link"
                    onClick={() =>
                      deleteTagRegexes(rule.id)
                        .then(() => {
                          dispatch(fetchTagRegexes("tag"));
                        })
                        .catch((err) =>
                          dispatch(
                            createAlert({
                              message: err.message || "Error deleting. Please try again.",
                              timeout: 0,
                              type: "error",
                            })
                          )
                        )
                    }
                  >
                    <FontAwesomeIcon icon="trash" />
                    <span className="ml-1">Delete</span>
                  </Button>
                </Col>
              </Row>
              <TagRuleForm
                rule={rule}
                onSubmit={(newRule) => {
                  dispatch(updateTagRuleAction({ ...newRule, id: rule.id }));
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default TagRules;
